import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable({

    providedIn:"root"

})

export class SpinnerService {

    _isloading = new Subject<boolean>();

    show(): void {

        this._isloading.next(true);

    }

    hide(): void {

        this._isloading.next(false);

    }

}